import { Link } from "react-router-dom";
import BrandLogo from "@/components/Monogram";
import GlobalMenu from "@/components/GlobalMenu";

/**
 * Universal page header — used on every standalone page.
 * Layout: Logo (left, clickable → /) | THE BLACK HOUSE wordmark (absolute center, single row)
 * Fixed at the top so it's visible regardless of scroll position.
 */
export default function PageHeader() {
  return (
    <header
      data-testid="page-header"
      className="global-brand-header fixed top-0 left-0 right-0 z-[250] bg-black/95 backdrop-blur-md border-b border-white/15 h-16 md:h-28"
    >
      {/* Metallic logo — left, scaled to sit optically with the header wordmark. */}
      <Link
        to="/"
        data-testid="page-header-logo"
        aria-label="THE BLACK HOUSE — Home"
        className="absolute left-3 md:left-8 top-1/2 -translate-y-1/2 z-10 flex items-center"
      >
        <BrandLogo size={40} testid="page-header-brand" />
      </Link>

      {/* Wordmark — dead-center of viewport (desktop only, mobile already gets it from the logo image) */}
      <Link
        to="/"
        data-testid="page-header-wordmark"
        aria-label="THE BLACK HOUSE — Home"
        className="global-brand-title hidden md:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-display font-bold text-white whitespace-nowrap md:text-[26px] uppercase hover:text-white/90 transition-colors"
        style={{ letterSpacing: "0.32em" }}
      >
        The Black House
      </Link>
      <GlobalMenu className="absolute right-3 md:right-8 top-1/2 -translate-y-1/2 z-20" />
    </header>
  );
}
